// Organik Kal cart: safe DOM rendering only.
(function initCartRenderer(global) {
    'use strict';

    const namespace = global.OrganikKalCart = global.OrganikKalCart || {};

    namespace.createCartRenderer = function createCartRenderer({ settings, locales, elements }) {
        const { escapeHtml, formatCurrency, positiveInteger, safeImageUrl } = namespace.utils;

        function renderItems(items, giftVariantId) {
            elements.items.innerHTML = items.map(item => {
                const isGift = item.id === giftVariantId
                    && item.properties
                    && item.properties._campaign_gift === 'true';
                const isEgg = [item.product_title, item.product_type, item.handle, item.url]
                    .filter(Boolean)
                    .join(' ')
                    .toLocaleLowerCase('tr-TR')
                    .includes('yumurta');
                const title = escapeHtml(item.product_title || item.title || 'Ürün');
                const variant = escapeHtml(item.variant_title || '');
                const image = escapeHtml(safeImageUrl(item.image));
                const key = escapeHtml(encodeURIComponent(String(item.key || item.id)));
                const quantity = positiveInteger(item.quantity);
                const originalPrice = item.original_line_price > item.line_price
                    ? `<span class="original-price">${formatCurrency(item.original_price / 100)}</span>`
                    : '';

                return `
                    <div class="lumicart-item ${isGift ? 'lumicart-gift-item' : ''}" data-cart-key="${key}" data-quantity="${quantity}">
                        <div class="lumicart-item-image">
                            <img src="${image}" alt="${title}" loading="lazy">
                        </div>
                        <div class="lumicart-item-details">
                            <h5 class="lumicart-item-title">${title}</h5>
                            <p class="lumicart-item-variant">${variant}</p>
                            ${isEgg ? deliveryNoteMarkup() : ''}
                            <div class="lumicart-item-price">
                                ${isGift
                                    ? `<span class="lumicart-free-gift-label">${escapeHtml(locales.free_gift_label)} ✓</span>`
                                    : `${originalPrice}${formatCurrency(item.price / 100)}`}
                            </div>
                            <div class="lumicart-item-actions">
                                ${isGift ? giftLabelMarkup() : quantityControlsMarkup(title, quantity)}
                            </div>
                        </div>
                        <div class="lumicart-item-loading" role="status" aria-live="polite">
                            <span class="lumicart-item-spinner" aria-hidden="true"></span>
                            <span>${escapeHtml(settings.deletingText || 'Siliniyor...')}</span>
                        </div>
                    </div>`;
            }).join('');
        }

        function deliveryNoteMarkup() {
            return `
                <div class="lumicart-item-delivery-note">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.1 6-11a6 6 0 1 0-12 0c0 5.9 6 11 6 11Z"/><circle cx="12" cy="10" r="2.2"/></svg>
                    <span>Özel kurye: Yalnızca Beşiktaş, Şişli ve Beyoğlu</span>
                </div>`;
        }

        function giftLabelMarkup() {
            return `<span class="lumicart-campaign-label">${escapeHtml(locales.campaign_reward || 'Kampanya Hediyesi')}</span>`;
        }

        function quantityControlsMarkup(title, quantity) {
            return `
                <div class="lumicart-quantity-selector">
                    <button type="button" class="lumicart-qty-btn" data-cart-action="decrease" aria-label="Adedi azalt">−</button>
                    <input type="text" class="lumicart-qty-input" value="${quantity}" readonly aria-label="Ürün adedi">
                    <button type="button" class="lumicart-qty-btn" data-cart-action="increase" aria-label="Adedi artır">+</button>
                </div>
                <button type="button" class="lumicart-item-remove" data-cart-action="remove" aria-label="${title} ürününü sepetten kaldır">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2M10 11v6M14 11v6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>`;
        }

        function renderUpsells(cartItems) {
            const products = Array.isArray(settings.upsellProducts) ? settings.upsellProducts : [];
            const available = products.filter(product => product.id
                && !cartItems.some(item => item.id === product.id));

            if (!settings.enableUpsell || available.length === 0) {
                elements.upsellContainer.style.display = 'none';
                elements.upsellWrapper.replaceChildren();
                return;
            }

            const multiplier = 1 - (Number(settings.upsellDiscount) || 0) / 100;
            elements.upsellContainer.style.display = 'block';
            elements.upsellWrapper.innerHTML = available.map(product => {
                const id = positiveInteger(product.id, 0);
                const title = escapeHtml(product.title || 'Ürün');
                const image = escapeHtml(safeImageUrl(product.image));
                const price = Number(product.price) / 100;
                const discountedPrice = price * multiplier;
                const priceMarkup = settings.upsellDiscount > 0
                    ? `<span class="upsell-discounted-price">${formatCurrency(discountedPrice)}</span><span class="upsell-old-price">${formatCurrency(price)}</span>`
                    : `<span class="upsell-price">${formatCurrency(price)}</span>`;

                return `
                    <div class="upsell-item">
                        <div class="upsell-image"><img src="${image}" alt="${title}" loading="lazy"></div>
                        <div class="upsell-info">
                            <div class="upsell-title">${title}</div>
                            <div class="upsell-pricing">${priceMarkup}</div>
                        </div>
                        <button type="button" class="btn-upsell-add" data-upsell-variant="${id}">${escapeHtml(locales.add)}</button>
                    </div>`;
            }).join('');
        }

        function renderSummary({ subtotal, totalDiscount, appliedDiscount, giftwrapFee, requiresShipping, giftUnlocked }) {
            elements.subtotal.textContent = formatCurrency(subtotal);
            elements.total.textContent = formatCurrency(Math.max(0, subtotal - appliedDiscount + giftwrapFee));
            elements.shipping.textContent = requiresShipping ? 'Ödeme adımında hesaplanır' : 'Kargo gerekmiyor';
            elements.shipping.classList.toggle('lumicart-shipping-fee--pending', requiresShipping);
            elements.discountLine.style.display = totalDiscount > 0 ? 'flex' : 'none';
            elements.discount.textContent = `-${formatCurrency(totalDiscount)}`;
            elements.giftLine.style.display = giftUnlocked ? 'flex' : 'none';

            if (giftUnlocked && settings.giftProductTitle) {
                elements.giftName.textContent = `${settings.giftProductTitle} (${locales.free_gift_label})`;
            }
            renderGiftwrapSummary(giftwrapFee);
        }

        function renderGiftwrapSummary(fee) {
            let row = document.getElementById('lumicart-giftwrap-summary-line');
            if (fee <= 0) {
                if (row) row.remove();
                return;
            }

            if (!row) {
                row = document.createElement('div');
                row.id = 'lumicart-giftwrap-summary-line';
                row.className = 'summary-line';
                row.append(document.createElement('span'), document.createElement('span'));
                elements.shipping.parentElement.before(row);
            }
            row.children[0].textContent = locales.giftwrap_summary || 'Hediye Paketi';
            row.children[1].textContent = formatCurrency(fee);
        }

        return Object.freeze({ renderItems, renderSummary, renderUpsells });
    };
})(window);
